import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import { ICardsState, ICardStateData } from '../ICardState';
import BaseModifierBehavior from './BaseModifierBehavior';
import { CardType } from 'Prototype/Level/Card/CardType';

export default class CardRewardModifierBehavior extends BaseModifierBehavior {
    public onOwnCardPlayed(state: ICardsState): ICardsState {
        return this.rewardCard(state);
    }

    public onOwnCardDiscarded(state: ICardsState): ICardsState {
        return this.rewardCard(state);
    }

    private rewardCard(state: ICardsState): ICardsState {
        if (this.modifier.properties.rewardGiven) return state;

        let cardsState = { ...state };
        const rewardCardID: string = this.modifier.properties.cardID;
        const cardData = cardsState.cards[rewardCardID];

        switch (cardData.type) {
            case CardType.joker_pre_booster:
                cardsState = CardStateHelper.setJokerPreBoosterCardInStack(cardsState, rewardCardID);

                cardsState = CardStateHelper.setStateTaskData(cardsState, {
                    task: CardTask.RECEIVE_JOKER_PRE_BOOSTER,
                    cards: [rewardCardID],
                });
                break;
            default:
        }

        if (state !== cardsState) {
            cardsState = CardStateHelper.clearUndoHistory(cardsState);
            cardsState = this.updateModifier(cardsState, this.cardID, {
                properties: {
                    ...this.modifier.properties,
                    rewardGiven: true,
                },
            });
        }

        return cardsState;
    }
}
